import { Directive, ElementRef, Input, Output, EventEmitter, Renderer2, OnInit, OnDestroy } from '@angular/core';
import interact from 'interactjs';
import { ReplaySubject, Subscription } from 'rxjs';

@Directive({
	selector: '[interactResizable]'
})

export class InteractResizableDirective implements OnInit, OnDestroy {
	@Input() interactOptionsResizable: any;
	@Input() interactSnapObjectSubject: ReplaySubject<any>;
	@Input() interactOptionsResizableSubject: ReplaySubject<any>;

	@Output() interactResizeStart: EventEmitter<any> = new EventEmitter<any>();
	@Output() interactResizing: EventEmitter<any> = new EventEmitter<any>();
	@Output() interactResizeEnd: EventEmitter<any> = new EventEmitter<any>();

	private interactable: interact.Interactable;
	private subscriptions: Subscription = new Subscription();

	private lastTop: number;
	private lastLeft: number;

	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) {
		this.interactable = interact(this.el.nativeElement);
	}

	ngOnInit() {
		this.interactable.resizable(this.createInteractObject({}));

		if (this.interactSnapObjectSubject) {
			this.subscriptions.add(this.interactSnapObjectSubject.subscribe((snapObject: any) => {
				this.lastLeft = this.el.nativeElement.offsetLeft;
				this.lastTop = this.el.nativeElement.offsetTop;
				this.renderer.setStyle(this.el.nativeElement, 'left', '0');
				this.renderer.setStyle(this.el.nativeElement, 'top', '0');

				this.interactable.resizable(this.createInteractObject(snapObject));

				this.renderer.setStyle(this.el.nativeElement, 'left', this.lastLeft + 'px');
				this.renderer.setStyle(this.el.nativeElement, 'top', this.lastTop + 'px');
			}));
		}

		if (this.interactOptionsResizableSubject) {

			this.subscriptions.add(this.interactOptionsResizableSubject.subscribe((options: any) => {
				this.interactOptionsResizable = options;
				this.interactable.resizable(this.createInteractObject(null));
			}));
		}
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	private createInteractObject(snapObject: any): any {
		const obj: any = {
			restrict: { restriction: 'parent' },
			allowFrom: '.resize-handle',
			snap: snapObject,
			snapSize: {
				targets: snapObject
			},
			edges: {
				top: '.resize-top',
				left: '.resize-left',
				bottom: '.resize-bottom',
				right: '.resize-right'
			},
			invert: 'none',
			onstart: (event: interact.InteractEvent) => {

				// reset x-y data for left/top sizing
				const target: any = event.target;
				target.setAttribute('data-x', 0);
				target.setAttribute('data-y', 0);
				target.setAttribute('data-w', 0);
				target.setAttribute('data-h', 0);
				// send changes
				this.interactResizeStart.emit({});
			},
			onmove: (event: any) => {
				const target: any = event.target;
				let x: number = (parseFloat(event.target.getAttribute('data-x')) || 0);
				let y: number = (parseFloat(event.target.getAttribute('data-y')) || 0);
				const w: number = parseFloat(event.rect.width);
				const h: number = parseFloat(event.rect.height);

				// translate when resizing from top or left edges
				x += event.deltaRect.left;
				y += event.deltaRect.top;

				target.setAttribute('data-x', x);
				target.setAttribute('data-y', y);
				target.setAttribute('data-w', w);
				target.setAttribute('data-h', h);

				target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)';

				event.target.style.width = w + 'px';
				event.target.style.height = h + 'px';
				// send changes
				this.interactResizing.emit({
					left: this.el.nativeElement.offsetLeft + x,
					top: this.el.nativeElement.offsetTop + y,
					width: w,
					height: h
				});
			},
			onend: (event: interact.InteractEvent) => {
				const target: any = event.target;

				const x: number = (parseFloat(event.target.getAttribute('data-x')) || 0);
				const y: number = (parseFloat(event.target.getAttribute('data-y')) || 0);
				const w: number = (parseFloat(event.target.getAttribute('data-w')) || 0);
				const h: number = (parseFloat(event.target.getAttribute('data-h')) || 0);

				target.style.webkitTransform = target.style.transform = '';

				let newX: number = this.el.nativeElement.offsetLeft;
				let newY: number = this.el.nativeElement.offsetTop;

				if (x !== 0) {
					newX += x;
				}
				if (y !== 0) {
					newY += y;
				}
				event.target.style.left = newX + 'px';
				event.target.style.top = newY + 'px';

				// send changes
				this.interactResizeEnd.emit({
					left: newX,
					top: newY,
					width: w,
					height: h,
					event
				});
			}
		};
		if (this.interactOptionsResizable) {
			return Object.assign(obj, this.interactOptionsResizable);
		}
		return obj;
	}
}
